import { useMemo } from 'react';
import type { IJobRun } from '../../../api';
import {
	DurationRender,
	LastUpdatedRender,
	ReadOnlyBadgeRender,
} from '../../../components/TableV2/render';
import type { ExtendedDataTableColumn } from '../../../components/TableV2/types';

export const useColumns = (): ExtendedDataTableColumn<IJobRun>[] => {
	const columns: ExtendedDataTableColumn<IJobRun>[] = useMemo(
		() => [
			{
				titleLabel: 'Started at',
				accessor: 'run_created_at',
				render: (record) => (
					<LastUpdatedRender<IJobRun>
						record={record}
						field={'run_created_at'}
					/>
				),
			},
			{
				titleLabel: 'Finished at',
				accessor: 'run_finished_at',
				render: (record) => (
					<LastUpdatedRender<IJobRun>
						record={record}
						field={'run_finished_at'}
					/>
				),
			},
			{
				titleLabel: 'Status',
				accessor: 'status',
				render: (record) => (
					<ReadOnlyBadgeRender
						record={record}
						field={'status'}
						options={[
							{
								option: 'error',
								variant: 'critical',
								label: 'Error',
							},
							{
								option: 'success',
								variant: 'success',
								label: 'Success',
							},
							{
								option: 'completed',
								variant: 'success',
								label: 'Completed',
							},
							{
								option: 'succeeded',
								variant: 'success',
								label: 'Success',
							}, // Glue saves success status as succeeded
							{
								option: 'running',
								variant: 'info',
								label: 'Running',
							},
							{
								option: 'canceled',
								variant: 'default',
								label: 'Cancelled',
							},
							{
								option: 'failed',
								variant: 'critical',
								label: 'Error',
							},
							{
								option: 'initializing',
								variant: 'info',
								label: 'Initializing',
							},
							{
								option: 'rendering',
								variant: 'info',
								label: 'Rendering',
							},
							{
								option: 'unknown',
								variant: 'default',
								label: 'Unknown',
							},
							{
								option: 'waitingToRun',
								variant: 'default',
								label: 'Waiting to Run',
							},
						]}
						nilOption={{
							option: 'Unknown error',
							variant: 'critical',
							label: 'Unknown error',
						}}
					/>
				),
			},
			{
				titleLabel: 'Duration',
				accessor: 'duration',
				render: (record) => (
					<DurationRender<IJobRun>
						record={record}
						field1={'run_created_at'}
						field2={'run_finished_at'}
					/>
				),
			},
		],
		[]
	);

	return columns;
};
